/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import { useContext, createContext } from 'react';
import { Mitigation, MitigationPack, MitigationPackUsage } from '../../customTypes';

export interface MitigationPacksContextApi {
  mitigationPacks: MitigationPack[];
  mitigationPackUsage: MitigationPackUsage;
  getMitigationPack: (id: string) => Promise<MitigationPack | undefined>;
  addMitigations: (mitigationPackId: string, mitigations: Mitigation[]) => Promise<void>;
}

const initialState: MitigationPacksContextApi = {
  mitigationPacks: [],
  mitigationPackUsage: {},
  getMitigationPack: () => Promise.resolve({
    id: '0',
    name: '',
    description: '',
    mitigations: [],
  }),
  addMitigations: () => Promise.resolve(),
};

export const MitigationPacksContext = createContext<MitigationPacksContextApi>(initialState);

export const useMitigationPacksContext = () => useContext(MitigationPacksContext);